export default __webpack_public_path__ + "static/media/ic_wallet_25.49558641.svg";